import { Component, OnInit } from '@angular/core';
import { BciWkModalService } from '@bci/webkitbci';
import { AppStore } from 'src/app/core';

@Component({
  selector: 'app-modal-code-wrong',
  templateUrl: './modal-code-wrong.component.html',
  styleUrls: ['./modal-code-wrong.component.scss'],
  standalone: false
})
export class ModalCodeWrongComponent implements OnInit {
  title = 'El código no es correcto';
  constructor(private modal: BciWkModalService, private appStore: AppStore) {}

  ngOnInit(): void {
    this.modal.setStyles({
      containerStyle: {
        maxWidth: '600px',
        width: '100%',
        padding: '32px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        gap: '16px',
        overflowY: 'hidden',
      },
    });
  }

  redirect() {
    const dashboardUrl = `${this.appStore.env.redirects.urlBase}/${this.appStore.origin}/agendamiento-sucursal/gestionar`;
    if (this.appStore.env && this.appStore.origin) {
      window.parent.location.href = dashboardUrl;
    }
  }

  close() {
    this.modal.close();
    this.redirect();
  }
}
